const CostForwarding = {
  Title: "CostForwarding.Title",
  Mark: "CostForwarding.Mark",
  HelpText: "CostForwarding.HelpText",
  Edit: "CostForwarding.Edit",
  EditButton: "CostForwarding.EditButton",
  Saved: "CostForwarding.Saved",
  Removed: "CostForwarding.Removed",
  Customer: "CostForwarding.Customer",
  Description: "CostForwarding.Description",
  NotSavedAfterCreate: "CostForwarding.NotSavedAfterCreate",
  Release: "CostForwarding.Release",
  ReleaseDescription: "CostForwarding.ReleaseDescription",
  Released: "CostForwarding.Released",
  ViewInvoiceDraft: "CostForwarding.ViewInvoiceDraft",
  LockedOnInvoiceDraft: "CostForwarding.LockedOnInvoiceDraft",
  LockedOnInvoiceDraftWithoutNumber: "CostForwarding.LockedOnInvoiceDraftWithoutNumber",
  LockedForwarded: "CostForwarding.LockedForwarded",
  LockedForwardedWithoutNumber: "CostForwarding.LockedForwardedWithoutNumber",
  ReleaseTitle: "CostForwarding.ReleaseTitle",
  ReleaseConfirm: "CostForwarding.ReleaseConfirm",
  }
export default CostForwarding;